<div data-cy="apps-empty-state" [ngClass]="{ 'apps-empty-state-container': view === 'EmptyState' }">
  <ng-content></ng-content>
  <ng-container [ngSwitch]="view">
    <ng-container *ngSwitchCase="'EmptyState'">
      <div class="apps-empty-state">
        <u-icon
          [model]="{
            type: 'img',
            value: {
              lightUrl: './assets/empty-state/no-apps/connect-apps-light.svg',
              darkUrl: './assets/empty-state/no-apps/connect-apps-dark.svg'
            }
          }"
        ></u-icon>
        <ng-container *ngTemplateOutlet="text"></ng-container>
        <ng-container *ngTemplateOutlet="connectButton"></ng-container>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'Banner'">
      <div class="apps-empty-state-banner">
        <ng-container *ngTemplateOutlet="appsIcon"></ng-container>
        <ng-container *ngTemplateOutlet="text"></ng-container>
        <ng-container *ngTemplateOutlet="connectButton"></ng-container>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'NoResults'">
      <div class="apps-empty-state-no-results">
        <ng-container *ngTemplateOutlet="text"></ng-container>
        <ng-container *ngTemplateOutlet="connectButton"></ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #appsIcon>
  <u-icon [model]="{ type: 'font', value: 'icon-apps' }" [styles]="{ fontSize: '21px' }"></u-icon>
</ng-template>

<ng-template #text>
  <div class="apps-empty-state-text">
    <span class="apps-empty-state-info-text">{{ isQuery ? queryText : infoText }}</span>
    <span class="apps-empty-state-connect-text">{{ connectText }}</span>
  </div>
</ng-template>

<ng-template #connectButton>
  <u-button class="apps-empty-state-button" label="Connect apps" type="primary" (onClick)="redirectEmptyState()"></u-button>
</ng-template>
